import { render, staticRenderFns } from "./EditModelParameters.vue?vue&type=template&id=5f46d4e4&"
import script from "./EditModelParameters.vue?vue&type=script&lang=ts&"
export * from "./EditModelParameters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports